import { createContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

export const MockInterviewContext = createContext();

const MockInterviewContextProvider = ({ children }) => {

    const mockId = new URLSearchParams(window.location.search).get('mock_id');
    const savedQuestionIdx = useSelector(store => store?.mocks?.[mockId]?.question_idx);

    const [consent, setConsent] = useState(false);
    const [questionIndex, setQuestionIndex] = useState(savedQuestionIdx ?? 0);
    const [uploading, setUploading] = useState(false);
    const [isInterviewCompleted, setIsInterviewCompleted] = useState(false);
    const [currentMockId, setCurrentMockId] = useState('');

    useEffect(() => {
        if (savedQuestionIdx !== undefined) {
            setQuestionIndex(savedQuestionIdx);
        }
    }, [savedQuestionIdx]);

    const consentAccepter = () => setConsent(true);
    const updateQuestionIndex = () => setQuestionIndex(pre => pre + 1);
    const updateInterviewStatusToEnd = () => setIsInterviewCompleted(true);

    return <MockInterviewContext.Provider
        value={{
            consent,
            consentAccepter,
            questionIndex,
            setQuestionIndex,
            uploading,
            setUploading,
            isInterviewCompleted,
            updateInterviewStatusToEnd,
            updateQuestionIndex,
            currentMockId,
            setCurrentMockId,
        }}>
        {children}
    </MockInterviewContext.Provider>
}

export default MockInterviewContextProvider;
